import {
  IconChecklist,
  IconSettings,
  IconUserCog,
  IconUsers,
  IconCalendar,
  IconUsersGroup,
  IconBuildingSkyscraper,
  IconFiles,
  IconShieldCheck,
  IconBuilding,
  IconUserShield,
  IconRobot,
  IconCoins,
  IconCreditCard,
  IconReceipt,
  IconFileText,
  IconHistory,
  IconLayoutDashboard,
  IconId,
  IconInbox,
  IconFileInvoice,
  IconUserCheck,
  IconUserShare,
  IconSchool,
} from '@tabler/icons-react'
import { type SidebarData } from '../types'
import { useAuthStore } from '@/stores/authStore';
import { UserPermission } from '@/constants/permissions';
 
// Export the base data so it can be used by the context provider
export const sidebarDataBase: SidebarData = {
  navGroups: [
    {
      title: "",
      items: [
        {
          title: 'dashboard',
          url: '/',
          icon: IconLayoutDashboard,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            // Hide dashboard for super admin users
            return user?.role !== 'Super Admin' && user?.role_name !== 'Super Admin';
          }
        },
        {
          title: 'calendar',
          url: '/dashboard',
          icon: IconCalendar,
          showIf: () => {
            const auth = useAuthStore.getState().auth;
            const user = auth.user;
            
            // Hide calendar for super admin users
            if (user?.role === 'Super Admin' || user?.role_name === 'Super Admin') return false;
            return auth.can(UserPermission.VIEW_RENDEZVOUS);

  
          }
        },
        {
          title: 'cases',
          url: '/cases',
          icon: IconChecklist,
          showIf: () => {
            const auth = useAuthStore.getState().auth;
            const user = auth.user;
            // Hide cases for super admin users
            if (user?.role === 'Super Admin' || user?.role_name === 'Super Admin') return false;
            if (user?.role === 'Super Admin') return false;
            
            return auth.can(UserPermission.VIEW_CASE);
          }
        },
        {
          title: 'clients',
          url: '/clients',
          icon: IconUsersGroup,
          showIf: () => {
            const auth = useAuthStore.getState().auth;
            const user = auth.user;
            // Hide clients for super admin users
            if (user?.role === 'Super Admin' || user?.role_name === 'Super Admin') return false;
            if (user?.role === 'Super Admin') return false;
            
            return auth.can(UserPermission.VIEW_CLIENT);
          }
        },
        {
          title: 'adversaries',
          url: '/adversaries',
          icon: IconUsers,
          showIf: () => {
            const auth = useAuthStore.getState().auth;
            const user = auth.user;
            // Hide for super admin users
            if (user?.role === 'Super Admin' || user?.role_name === 'Super Admin') return false;
            if (user?.role === 'Super Admin') return false;

            return auth.can(UserPermission.VIEW_CASE_PARTY);
          }
        },
        {
          title: 'facturation',
          url: '/invoices',
          icon: IconFileInvoice,
          showIf: () => {
            const auth = useAuthStore.getState().auth;
            const user = auth.user;
            if (user?.role === 'Super Admin' || user?.role_name === 'Super Admin') return false;
            return auth.can(UserPermission.VIEW_CLIENT_INVOICE);
          }
        },
        {
          title: 'depenses',
          url: '/expenses',
          icon: IconReceipt,
          showIf: () => {
            const auth = useAuthStore.getState().auth;
            const user = auth.user;
            if (user?.role === 'Super Admin' || user?.role_name === 'Super Admin') return false;
            return auth.can(UserPermission.VIEW_EXPENSE);
          }
        },
        {
          title: 'honoraires',
          url: '/honoraires',
          icon: IconCoins,
          showIf: () => {
            const auth = useAuthStore.getState().auth;
            const user = auth.user;
            // Hide for super admin users
            if (user?.role === 'Super Admin' || user?.role_name === 'Super Admin') return false;
            
            return auth.can(UserPermission.VIEW_CASE); 
          }
        },
        {
          title: 'documents',
          url: '/documents',
          icon: IconFiles,
          showIf: () => {
            const auth = useAuthStore.getState().auth;
            const user = auth.user;
            if (user?.role === 'Super Admin' || user?.role_name === 'Super Admin') return false;
            return auth.can(UserPermission.VIEW_CASE);
          }
        },
        {
          title: 'users',
          url: '/users',
          icon: IconUsers,
          showIf: () => {
            const auth = useAuthStore.getState().auth;
            const user = auth.user;
            // Hide regular users for super admin users (they have their own super admin users page)
            if (user?.role === 'Super Admin' || user?.role_name === 'Super Admin') return false;
            if (user?.role === 'Super Admin') return false;

            return auth.can(UserPermission.VIEW_USER);
          }
        },
        {
          title: 'affectation',
          url: '/affectation',
          icon: IconUserCheck,
          showIf: () => {
            const auth = useAuthStore.getState().auth;
            const user = auth.user;
            if (user?.role === 'Super Admin' || user?.role_name === 'Super Admin') return false;
            return auth.can(UserPermission.MANAGE_AFFECTATION);
          }
        },
        {
          title: 'external_lawyers',
          url: '/external-lawyers',
          icon: IconUserShare,
          showIf: () => {
            const auth = useAuthStore.getState().auth;
            const user = auth.user;
            if (user?.role === 'Super Admin' || user?.role_name === 'Super Admin') return false;
            return auth.can(UserPermission.MANAGE_EXTERNAL_LAWYERS);
          }
        },
        {
          title: 'guides_resources',
          url: '/guides',
          icon: IconSchool,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role !== 'Super Admin' && user?.role_name !== 'Super Admin';
          }
        },
        {
          title: 'document_templates',
          url: '/cabinet-document-templates',
          icon: IconFileText,
          showIf: () => {
            const auth = useAuthStore.getState().auth;
            const user = auth.user;
            if (user?.role === 'Super Admin' || user?.role_name === 'Super Admin') return false;
            if (user?.role === 'Super Admin') return false;
            
            return auth.can(UserPermission.VIEW_DOCUMENT_TEMPLATE);
          }
        },
 
        {
          title: 'super_admin_dashboard',
          url: '/super-admin-dashboard',
          icon: IconShieldCheck,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
        {
          title: 'super_admin_cabinets',
          url: '/super-admin-cabinets',
          icon: IconBuilding,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
        {
          title: 'super_admin_users',
          url: '/super-admin-users',
          icon: IconUserShield,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
        {
          title: 'Plans',
          url: '/super-admin-plans',
          icon: IconChecklist,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
        {
          title: 'Subscriptions',
          url: '/super-admin-subscriptions',
          icon: IconReceipt,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
        {
          title: 'Payments',
          url: '/super-admin-payments',
          icon: IconCreditCard,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
    
 
        {
          title: 'credit_management',
          url: '/super-admin-credit-management',
          icon: IconCoins,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
        {
          title: 'document_templates',
          url: '/super-admin-document-templates',
          icon: IconFileText,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
        {
          title: 'template_requests',
          url: '/super-admin-template-requests',
          icon: IconFileText,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
        {
          title: 'chatbot_configuration',
          url: '/super-admin-chatbot-config',
          icon: IconRobot,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
        {
          title: 'super_admin_feedback',
          url: '/super-admin-feedback',
          icon: IconRobot,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
        {
          title: 'audit_logs',
          url: '/super-admin-audit-logs',
          icon: IconHistory,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
        {
          title: 'super_admin_logs',
          url: '/super-admin-logs',
          icon: IconRobot,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
        {
          title: 'Blog',
          url: '/super-admin-blog',
          icon: IconFileText,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
        {

          title: 'Domains',
          url: '/super-admin-blog-domains',
          icon: IconFileText,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
                {
          title: 'CRM',
          url: '/super-admin-crm',
          icon: IconBuilding,

          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
        {
          title: 'lp_page_title',
          url: '/super-admin-lawyer-profiles',
          icon: IconId,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
        {
          title: 'lr_page_title',
          url: '/super-admin-listing-requests',
          icon: IconInbox,
          showIf: () => {
            const user = useAuthStore.getState().auth.user;
            return user?.role === 'Super Admin' || user?.role_name === 'Super Admin';
          }
        },
      ]
    },
    {
      title: 'other_pages',
      items: [
        {
          title: 'settings',
          icon: IconSettings,
          items: [
            {
              title: 'account',
              url: '/profile',
              icon: IconUserCog,
            },
            {
              title: 'lawyer_profile_beta',
              url: '/lawyer-profile',
              icon: IconId,
              showIf: () => {
                const auth = useAuthStore.getState().auth;
                return auth.can(UserPermission.VIEW_LAWYER_PROFILE);
              }
            },
            {
              title: 'cabinet_settings',
              url: '/cabinet-settings',
              icon: IconBuildingSkyscraper,
              showIf: () => {
                const auth = useAuthStore.getState().auth;
                return auth.user?.is_admin === true || auth.can(UserPermission.CHANGE_CABINET);
              }
            },
            {
              title: 'roles_management',
              url: '/cabinet-roles',
              icon: IconUserShield,
              showIf: () => {
                const auth = useAuthStore.getState().auth;
                return auth.user?.is_admin === true || auth.can(UserPermission.VIEW_ROLE);
              }
            },
            {
              title: 'plans',
              url: '/cabinet-plans',
              icon: IconChecklist,
              showIf: () => {
                const user = useAuthStore.getState().auth.user;
                return user?.is_admin === true && user?.role !== 'Super Admin' && user?.role_name !== 'Super Admin';
              }
            },
            {
              title: 'subscriptions',
              url: '/cabinet-subscriptions',
              icon: IconReceipt,
              showIf: () => {
                const user = useAuthStore.getState().auth.user;
                return user?.is_admin === true && user?.role !== 'Super Admin' && user?.role_name !== 'Super Admin';
              }
            },
            {
              title: 'invoices',
              url: '/cabinet-billing',
              icon: IconReceipt,
              showIf: () => {
                const user = useAuthStore.getState().auth.user;
                return user?.is_admin === true && user?.role !== 'Super Admin' && user?.role_name !== 'Super Admin';
              }
            }
          ],
        }
      ],
    },
  ],
}